"use client";

import React from "react";
import { MapPin, Phone, Mail, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const location = {
  city: "St. Veit an der Glan",
  address: "Klagenfurter Str. 67, 9300 St. Veit",
  country: "Kärnten",
  lat: "46.7612° N",
  lng: "14.3668° E",
  email: "office@cup4us.at",
  phone: "+43 660 933 76 67",
  status: "Hauptstandort"
};
export default function GlobalStudio() {
  return <section data-section-id="223538" id="unser-standort" className="bg-background text-foreground relative w-full overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-5" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--color-background)_100%)]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        {}
        <div className="mb-16 flex flex-col items-start justify-between gap-6 border-b border-border/50 pb-8 md:flex-row md:items-end">
          <div className="max-w-2xl space-y-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-accent px-3 py-1 text-xs font-mono text-primary uppercase tracking-wider">
              <Globe className="size-3" />
              <span>Regionales Netzwerk</span>
            </div>
            <h2 className="font-default text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl text-secondary">
              Unser Standort
            </h2>
            <p className="text-muted-foreground max-w-xl text-lg font-default">Besuchen Sie uns an unserem zentralen Standort in St. Veit. Hier koordinieren wir die Reinigung, Lagerung und Logistik für alle Aufträge.</p>
          </div>
          <div className="shrink-0">
            <Button variant="outline" className="rounded-full border-primary/50 text-primary hover:bg-primary/10 font-default uppercase tracking-wider text-xs">
              <Link to="/ContactPage">Anfrage senden</Link>
            </Button>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
          {}
          <div className="lg:col-span-1 bg-card/50 backdrop-blur-sm border border-border/50 rounded-3xl p-8 flex flex-col justify-between shadow-xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full -mr-16 -mt-16 blur-3xl" />
            
            <div className="space-y-8 relative z-10">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent px-3 py-1 text-[10px] font-mono font-medium text-primary border border-primary/10 mb-4">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
                  {location.status}
                </span>
                <h3 className="text-3xl font-bold text-secondary mb-2">{location.city}</h3>
                <p className="text-muted-foreground flex items-start gap-2">
                  <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                  <span>{location.address}</span>
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 text-xs font-mono bg-muted/50 p-4 rounded-xl border border-border/30">
                <div className="flex flex-col">
                  <span className="text-muted-foreground text-[9px] uppercase mb-1">Breite</span>
                  <span className="text-secondary font-semibold">{location.lat}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-muted-foreground text-[9px] uppercase mb-1">Länge</span>
                  <span className="text-secondary font-semibold">{location.lng}</span>
                </div>
              </div>

              <div className="space-y-4">
                <Link to={`mailto:${location.email}`} className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <div className="size-10 rounded-full bg-accent flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all">
                    <Mail className="size-5" />
                  </div>
                  <span className="font-default">{location.email}</span>
                </Link>
                <Link to={`tel:${location.phone}`} className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <div className="size-10 rounded-full bg-accent flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all">
                    <Phone className="size-5" />
                  </div>
                  <span className="font-default">{location.phone}</span>
                </Link>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-border/50">
              <Button className="w-full rounded-xl py-6" asChild>
                <Link to="https://www.google.com/maps/dir/?api=1&destination=46.7612839,14.3668781" newTab>
                  Route planen
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-2 relative w-full min-h-[400px] rounded-3xl border border-border/30 bg-card/20 backdrop-blur-sm overflow-hidden shadow-xl">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2715.5!2d14.3668781!3d46.7612839!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47706d03362e2b47:0x6d226f120010243e!2sCup4us%20OG!5e0!3m2!1sde!2sat!4v1710000000000" className="absolute inset-0 w-full h-full grayscale contrast-125 opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-500" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            
            {}
            <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-primary/30 pointer-events-none" />
            <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-primary/30 pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-primary/30 pointer-events-none" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-primary/30 pointer-events-none" />
          </div>
        </div>

        {}
        
      </div>
    </section>;
}